(function () {
  var BASE = 45, KEY = 'rotDraft';
  var each = function (n) { return n >= 4 ? 27.5 : n === 3 ? 30 : n === 2 ? 35 : 45; };
  var total = function (n) { return n * each(n); };
  var $$ = function (v) { return '$' + (v % 1 ? v.toFixed(2) : v); };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };
  var WORD = ['', 'one', 'two', 'three', 'four'];
  var ORD = ['', 'first', 'second', 'third', 'fourth'];
  var LADDER = '2 for $70, 3 for $90, 4+ at $27.50 each';
  var BMSG = ['', 'Add 1 more: both drop to $35, plus free shipping.', 'Add 1 more and all drop to $30.', 'Add 1 more and all drop to $27.50.', 'Best price unlocked: $27.50 each.'];
  function products() { var el = document.querySelector('[data-rot-products]'); try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; } }
  function tiersHTML(n) {
    var h = '<div class="rot-tiers" role="group" aria-label="How many hats">';
    for (var i = 1; i <= 4; i++) {
      h += '<button type="button" class="rot-tier" data-n="' + i + '" aria-pressed="' + (i === n) + '">' + (i === 3 ? '<span class="rot-tag">Best value</span>' : '') +
        '<span class="l">' + (i === 1 ? '1 hat' : i === 4 ? '4+ hats' : i + ' hats') + '</span><span class="p">' + $$(total(i)) + '</span>' +
        '<span class="e">' + (i === 1 ? 'Single' : $$(each(i)) + ' each') + '</span><span class="s">' + (i > 1 ? 'Save ' + $$(i * BASE - total(i)) : '') + '</span></button>';
    }
    return h + '</div>';
  }
  function steps(n) { var s = '<div class="rot-steps" aria-hidden="true">'; for (var i = 1; i <= 4; i++) s += '<span class="' + (n >= i ? 'on' : '') + '"></span>'; return s + '</div>'; }
  function pdpVariant(fb) { var f = document.querySelector('#MainContent .product-form-wrapper [name="id"]'); return f && f.value ? Number(f.value) : fb; }
  function postAdd(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
  }
  function addToCart(variants, btn) {
    var map = {}; variants.forEach(function (v) { map[v] = (map[v] || 0) + 1; });
    var items = Object.keys(map).map(function (v) { return { id: Number(v), quantity: map[v] }; });
    var old = btn.innerHTML; btn.disabled = true; btn.textContent = 'Adding';
    return postAdd(items).then(function () {
      btn.disabled = false; btn.innerHTML = old;
      try { sessionStorage.removeItem(KEY); } catch (e) {}
      if (document.querySelector('cart-drawer')) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      else window.location.href = '/cart';
    }).catch(function () { btn.disabled = false; btn.innerHTML = old; alert('Something went wrong adding your hats. Please try again.'); });
  }

  document.querySelectorAll('[data-rot="pdp"]:not([data-ready])').forEach(function (el) {
    el.setAttribute('data-ready', '');
    if (el.hasAttribute('data-auto')) {
      var wrap = document.querySelector('#MainContent .product-form-wrapper');
      if (!wrap) { el.remove(); return; }
      wrap.parentNode.insertBefore(el, wrap);
      wrap.style.display = 'none';
      document.querySelectorAll('[data-av65]').forEach(function (b) { b.style.display = 'none'; });
    }
    var cur = JSON.parse(el.getAttribute('data-current'));
    var all = products().filter(function (p) { return p.id !== cur.id; });
    var n = Math.min(4, Math.max(1, Number(el.getAttribute('data-default')) || 3));
    var picks = [];
    var saved = null; try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (saved && saved.ids && saved.ids.length > 1 && Date.now() - saved.t < 3600000) {
      n = Math.min(4, Math.max(2, saved.n || 3));
      picks = saved.ids.filter(function (id) { return id !== cur.id; }).map(function (id) { return all.find(function (x) { return x.id === id; }); }).filter(Boolean).slice(0, n - 1);
    }
    function save() {
      try {
        if (picks.length) sessionStorage.setItem(KEY, JSON.stringify({ n: n, ids: [cur.id].concat(picks.map(function (x) { return x.id; })), t: Date.now() }));
        else sessionStorage.removeItem(KEY);
      } catch (e) {}
    }
    function ctaFor(missing) {
      if (n === 1) return 'Add to cart, $45';
      if (missing > 0) return 'Choose ' + missing + ' more ' + (missing === 1 ? 'hat' : 'hats');
      return 'Add the Rotation, ' + $$(total(n)) + ' <s>' + $$(n * BASE) + '</s>';
    }
    function render() {
      picks = picks.slice(0, n - 1);
      var missing = n - 1 - picks.length;
      var h = '<div class="rot-head"><p class="rot-eyebrow">The Rotation</p><span>Mix any styles</span></div>' + tiersHTML(n);
      if (n > 1) {
        h += '<p class="rot-label">Your ' + WORD[n] + '</p><div class="rot-slots">';
        h += '<div class="rot-slot"><div class="box"><img src="' + esc(cur.i) + '" alt="' + esc(cur.t) + '"></div><span class="rot-note">This hat</span></div>';
        for (var i = 0; i < n - 1; i++) {
          var p = picks[i];
          h += p ? '<div class="rot-slot"><div class="box"><img src="' + esc(p.i) + '" alt="' + esc(p.t) + '"></div><button type="button" class="rot-link" data-remove="' + i + '">Remove</button></div>'
                 : '<div class="rot-slot"><div class="box empty' + (i === picks.length ? ' next' : '') + '">Hat ' + (i + 2) + '</div><span class="rot-note"></span></div>';
        }
        h += '</div>';
        if (missing > 0) {
          var chosen = picks.map(function (x) { return x.id; });
          h += '<p class="rot-label">Choose your ' + ORD[picks.length + 2] + ' hat. <b>Every hat in your ' + WORD[n] + ' is ' + $$(each(n)) + ', plus free shipping.</b></p><div class="rot-picker">';
          all.filter(function (x) { return chosen.indexOf(x.id) === -1; }).forEach(function (x) {
            h += '<button type="button" class="rot-opt" data-pick="' + x.id + '" aria-label="Add ' + esc(x.t) + ' for ' + $$(each(n)) + '"><span class="im"><img src="' + esc(x.i) + '" alt="" loading="lazy"></span><span class="n">' + esc(x.t) + '</span><span class="c">' + esc(x.c !== x.t ? x.c : '') + '</span>' +
              '<span class="pr"><s>$45</s><b>' + $$(each(n)) + '</b></span><span class="sp"></span><span class="a">+ Add</span></button>';
          });
          h += '</div>';
        }
      }
      var ready = n === 1 || missing === 0;
      h += '<button type="button" class="rot-btn" data-cta' + (!ready ? ' disabled' : '') + '>' + ctaFor(missing) + '</button>';
      h += '<p class="rot-fine">' + (n > 1 ? 'Free shipping. Easy exchanges on every hat.' : 'Add a second hat: both drop to $35, plus free shipping.') + '</p>';
      el.innerHTML = h;
      save();
    }
    el.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t) return;
      if (t.hasAttribute('data-n')) { n = Number(t.getAttribute('data-n')); render(); return; }
      if (t.hasAttribute('data-remove')) { picks.splice(Number(t.getAttribute('data-remove')), 1); render(); return; }
      if (t.hasAttribute('data-pick')) { var id = Number(t.getAttribute('data-pick')); if (picks.length < n - 1) { picks.push(all.find(function (x) { return x.id === id; })); render(); } return; }
      if (t.hasAttribute('data-cta') && !t.disabled) addToCart([pdpVariant(cur.v)].concat(picks.map(function (x) { return x.v; })), t);
    });
    render();
  });

  document.querySelectorAll('product-bundle:not([data-rot-ready])').forEach(function (pb) {
    pb.setAttribute('data-rot-ready', '');
    var side = pb.querySelector('.product-bundle__sidebar'); if (!side) return;
    var title = side.querySelector('.title-wrapper'), body = side.querySelector('.product-bundle__body');
    var totalEl = pb.querySelector('[data-product-bundle-total-with-currency]');
    var line = document.createElement('div'); line.className = 'rot rot-bl';
    var wrapEl = document.createElement('div'); wrapEl.className = 'rot rot-bwrap';
    if (title) title.appendChild(line);
    var countNow = function () { var t = totalEl ? parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) : 0; return t > 0 ? Math.round(t / BASE) : 0; };
    var last = -1;
    var paint = function () {
      if (body && !body.contains(wrapEl)) body.insertBefore(wrapEl, body.firstChild);
      var n = countNow(); if (n === last) return; last = n;
      line.innerHTML = '<div class="rot-bl-row"><span class="m">' + LADDER + '</span>' + (n > 0 ? '<span class="pr">' + (n > 1 ? '<s>' + $$(n * BASE) + '</s>' : '') + '<b>' + $$(total(n)) + '</b></span>' : '') + '</div>';
      var h = '<div class="rot-bladder">';
      for (var i = 1; i <= 4; i++) h += '<div class="' + (n === 0 || Math.min(n, 4) === i ? 'on' : '') + '"><span>' + (i === 1 ? '1 hat' : i === 4 ? '4+ hats' : i + ' hats') + '</span><b>' + $$(total(i)) + '</b><em>' + (i === 1 ? 'Single' : $$(each(i)) + ' each') + '</em></div>';
      wrapEl.innerHTML = h + '</div><p class="rot-bnote">' + BMSG[Math.min(n, 4)] + '</p>';
    };
    if (totalEl) new MutationObserver(paint).observe(totalEl, { childList: true, characterData: true, subtree: true });
    paint();
  });

  if (document.querySelector('[data-rot-drawer-mode]') && !window.__rotationDrawer) {
    window.__rotationDrawer = true;
    var ELIG = []; try { ELIG = JSON.parse(document.querySelector('[data-rot-eligible]').textContent); } catch (e) {}
    var lastCart = { items: [] };
    var count = function (cart) { return (cart.items || []).reduce(function (s, it) { return ELIG.indexOf(it.product_id) > -1 ? s + it.quantity : s; }, 0); };
    var addTab = function () { return document.querySelector('cart-drawer .drawer__tab[aria-controls^="RecentlyViewed-"]'); };
    var cartTab = function () { return document.querySelector('cart-drawer .drawer__tab[aria-controls^="MiniCart-"]'); };
    var onAdd = function () { var t = addTab(); return !!t && t.getAttribute('aria-expanded') === 'true'; };
    var paintBar = function (cart) {
      var mini = document.querySelector('cart-drawer [id^="MiniCart-"]'); if (!mini) return;
      var bar = document.querySelector('[data-rot-status]');
      if (!bar) { bar = document.createElement('div'); bar.className = 'rot rot-status'; bar.setAttribute('data-rot-status', ''); mini.parentNode.insertBefore(bar, mini); }
      var n = count(cart);
      var txt = n === 0 ? '<b>The Rotation.</b> 2 for $70, 3 for $90.' : n === 1 ? '<b>1 hat.</b> Add 1 more: both $35, free shipping.' : '<b>' + n + ' hats, ' + $$(each(n)) + ' each.</b> Free shipping.';
      bar.innerHTML = '<div class="row"><span class="t">' + txt + '</span>' + (addTab() ? '<button type="button" class="rot-addlink" data-rot-switch>' + (onAdd() ? 'View cart' : '+ Add a hat') + '</button>' : '') + '</div>' + steps(n);
    };
    var paintAdd = function (cart) {
      var panel = document.querySelector('cart-drawer [id^="RecentlyViewed-"]'); if (!panel) return;
      var rv = panel.querySelector('recently-viewed'); if (rv) rv.style.display = 'none';
      var box = panel.querySelector('[data-rot-add]');
      if (!box) { box = document.createElement('div'); box.className = 'rot rot-add drawer__scrollable relative flex flex-col'; box.setAttribute('data-rot-add', ''); panel.appendChild(box); }
      var inCart = (cart.items || []).map(function (it) { return it.product_id; });
      var n = count(cart), next = n + 1;
      var list = products().filter(function (p) { return inCart.indexOf(p.id) === -1; });
      var h = '<p class="rot-add-h">' + (n === 0 ? '<b>Start your Rotation.</b> 2 for $70, 3 for $90, 4+ at $27.50 each.' : n >= 4 ? '<b>Best price unlocked.</b> Every hat is $27.50.' : '<b>Add hat ' + next + '</b> and every hat drops to ' + $$(each(next)) + '.') + '</p><ul>';
      list.forEach(function (p) {
        h += '<li><span class="im"><img src="' + esc(p.i) + '" alt="" loading="lazy"></span><span class="tx"><span class="n">' + esc(p.t) + '</span><span class="c">' + esc(p.c !== p.t ? p.c : '') + '</span><span class="pr">' + (each(next) < BASE ? '<s>$45</s>' : '') + '<b>' + $$(each(next)) + '</b></span></span><button type="button" class="rot-plus" data-rot-v="' + p.v + '" aria-label="Add ' + esc(p.t) + '">+</button></li>';
      });
      box.innerHTML = h + '</ul>';
    };
    var paintCart = function (cart) { lastCart = cart; paintBar(cart); paintAdd(cart); };
    var refresh = function () { fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(paintCart).catch(function () {}); };
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-rot-switch]');
      if (sw) { var t = onAdd() ? cartTab() : addTab(); if (t) t.click(); setTimeout(function () { paintBar(lastCart); }, 60); return; }
      if (e.target.closest('cart-drawer .drawer__tab')) { setTimeout(function () { paintBar(lastCart); }, 60); return; }
      var plus = e.target.closest('[data-rot-v]');
      if (plus && !plus.disabled) {
        plus.disabled = true; plus.textContent = '…';
        postAdd([{ id: Number(plus.getAttribute('data-rot-v')), quantity: 1 }])
          .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } })); })
          .catch(function () { plus.disabled = false; plus.textContent = '+'; });
      }
    });
    document.addEventListener('cart:updated', function (e) { if (e.detail && e.detail.cart && e.detail.cart.items) paintCart(e.detail.cart); else refresh(); });
    document.addEventListener('cart:refresh', function () { setTimeout(refresh, 400); });
    var of = window.fetch;
    window.fetch = function () { var u = arguments[0] && arguments[0].url ? arguments[0].url : String(arguments[0]); var p = of.apply(this, arguments); if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(function () { setTimeout(refresh, 350); }); return p; };
    refresh();
  }
})();